import { render, staticRenderFns } from "./ListaCanalesVenta.vue?vue&type=template&id=5ae9f2fd"
import script from "./ListaCanalesVenta.vue?vue&type=script&lang=js"
export * from "./ListaCanalesVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports